export default { sha: '5faf4625b1d1be7fd82d3d48118117c68d0aca71', buildNumber: 'undefined' }
